<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description?: string
    }[]
  }>(),
  {
    title: 'Proses Integrasi API AnterAja melalui KiriminAja',
    items: () => [
      {
        title: 'Konsultasi Awal',
        description:
          'Hubungi tim sales KiriminAja untuk memetakan kebutuhan bisnis & volume pengiriman.'
      },
      {
        title: 'Onboarding & Commitment Fee',
        description:
          'Commitment fee Rp2.000.000 (deposit saldo pengiriman setelah aktif).'
      },
      {
        title: 'Integrasi Sistem',
        description:
          'Developer Anda akan didampingi tim teknis KiriminAja dan dokumentasi lengkap.'
      },
      {
        title: 'Go Live',
        description:
          'Sistem siap digunakan untuk order, tracking, dan notifikasi real-time.'
      }
    ]
  }
)
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle class="lg:text-center" :title="title" />
      <UiCarouselFeature
        :items="items"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
